import React, { useState, useEffect } from "react"
import { Row, Col, Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input } from "reactstrap"
import Datatables from "components/Datatables/datatable"
import Select from "react-select"
import { get, post } from "helpers/api_helper"
import { PAYROLL_BONUS_URL } from "helpers/url_helper"
import Notifications from "components/Notifications"

const Bonus = () => {
    const [modal, setModal] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [dataRows, setDataRows] = useState({ rows: [], total_rows: 0 })
    const [pagination, setPagination] = useState({ limit: 10, page: 1, search: "" })
    
    const [formData, setFormData] = useState({
        title: "",
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
        value_type: "Fixed",
        value: "",
        branch_id: "1"
    })

    const toggleModal = () => {
        if (modal) {
            setFormData({ title: "", month: new Date().getMonth() + 1, year: new Date().getFullYear(), value_type: "Fixed", value: "", branch_id: "1" })
            setIsEdit(false)
        }
        setModal(!modal)
    }

    const brownBtnStyle = { backgroundColor: "#3d1e08", borderColor: "#3d1e08", color: "#fff" }

    const getData = async () => {
        setIsLoading(true)
        const res = await get(PAYROLL_BONUS_URL)
        if (res.status === 200) {
            setDataRows(res.response)
        }
        setIsLoading(false)
    }

    useEffect(() => {
        getData()
    }, [pagination])

    const handleSubmit = async (e) => {
        e.preventDefault()
        const res = isEdit 
            ? await post(`${PAYROLL_BONUS_URL}_update`, formData)
            : await post(PAYROLL_BONUS_URL, formData)
            
        if (res.status === 200 || res.status === true) {
            Notifications("success", res.message)
            toggleModal()
            getData()
        } else {
            Notifications("error", res.message)
        }
    }

    const handleEdit = (row) => {
        setFormData({ ...row })
        setIsEdit(true)
        setModal(true)
    }

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this bonus?")) {
            const res = await get(`${PAYROLL_BONUS_URL}_delete?id=${id}`)
            if (res.status === 200 || res.status === true) {
                Notifications("success", res.message)
                getData()
            } else {
                Notifications("error", res.message)
            }
        }
    }

    const columns = [
        { dataField: "id", text: "#" },
        { dataField: "title", text: "TITLE" },
        { dataField: "month", text: "MONTH" },
        { dataField: "year", text: "YEAR" },
        { dataField: "value_type", text: "VALUE TYPE" },
        { dataField: "value", text: "VALUE" },
        {
            dataField: "status",
            text: "STATUS",
            formatter: (cell) => (
                <div className="form-check form-switch" dir="ltr">
                    <input type="checkbox" className="form-check-input" defaultChecked={cell == 1} />
                </div>
            )
        },
        {
            dataField: "action",
            text: "ACTION",
            formatter: (cell, row) => (
                <>
                    <Button color="light" size="sm" className="me-1" onClick={() => handleEdit(row)}><i className="far fa-edit text-primary"></i></Button>
                    <Button color="light" size="sm" onClick={() => handleDelete(row.id)}><i className="far fa-times-circle text-danger"></i></Button>
                </>
            )
        }
    ]

    return (
        <React.Fragment>
            <Datatables 
                title="Bonus Management"
                titleClass="h5"
                columns={columns} 
                rows={dataRows.rows} 
                keyField="id" 
                rowsLength={dataRows.total_rows} 
                isSearch={false} 
                isAdd={true} 
                btnTitle="Add Bonus"
                btnColor="success"
                handleAddButton={toggleModal}
                ssr={setPagination} 
                loading={isLoading} 
            />

            <Modal isOpen={modal} toggle={toggleModal} size="lg">
                <ModalHeader toggle={toggleModal}>{isEdit ? "Edit" : "Add"} Bonus</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col md={12}>
                                <FormGroup>
                                    <Label>Title <span className="text-danger">*</span></Label>
                                    <Input 
                                        type="text" 
                                        placeholder="Enter title" 
                                        value={formData.title}
                                        onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Month <span className="text-danger">*</span></Label>
                                    <Input 
                                        type="number" 
                                        min="1" max="12"
                                        value={formData.month}
                                        onChange={(e) => setFormData({ ...formData, month: e.target.value })}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Year <span className="text-danger">*</span></Label>
                                    <Input 
                                        type="number" 
                                        value={formData.year}
                                        onChange={(e) => setFormData({ ...formData, year: e.target.value })}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Value Type <span className="text-danger">*</span></Label>
                                    <Select 
                                        options={[{ label: "Fixed", value: "Fixed" }, { label: "Percentage", value: "Percentage" }]} 
                                        value={{ label: formData.value_type, value: formData.value_type }}
                                        onChange={(opt) => setFormData({ ...formData, value_type: opt.value })}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Value <span className="text-danger">*</span></Label>
                                    <Input 
                                        type="text" 
                                        placeholder="Enter value" 
                                        value={formData.value}
                                        onChange={(e) => setFormData({ ...formData, value: e.target.value })}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="mt-3">
                            <Button style={brownBtnStyle} type="submit">{isEdit ? "Update" : "Create"}</Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
}

export default Bonus
